import initializeReducer from './redux/reducer';
import initializeSaga from './redux/saga';
import initializeSelectors from './redux/selectors';
import actions from './redux/actions';
import actionTypes from './redux/types';
export const initialize = ({ reducerPath, includeResources }) => {
    const reducer = initializeReducer(includeResources);
    const saga = initializeSaga(includeResources);
    const selectors = initializeSelectors(reducerPath);
    return { reducer, saga, selectors, actions, actionTypes };
};
export { default as ResourceTypes } from './resourceTypes';
export const ContextHydratingActions = actions;
